import React, { useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles.scss';
import { useLocalization } from '@client/internationalization';
import StickyContainerView from '@client/shared-components/layout/StickyContainerView';
import { FAQSectionList } from './FaqSectionList';

export interface FaqDialogProps {
  open: boolean;
  onClose: () => void;
}

export const FaqDialog: React.FC<FaqDialogProps> = ({ open, onClose }) => {
  const { localizeMessage } = useLocalization('faqhelpcenter');
  const [mailtoHref, setMailtoHref] = React.useState('');

  const generateMailto = () => {
    const randomNumber = Math.floor(10000 + Math.random() * 90000);
    const mailtoSubject = `MIN${randomNumber}`;
    const emailId = 'minna.customerservice.sg@mastercard.com';
    return `mailto:${emailId}?subject=${encodeURIComponent(mailtoSubject)}`;
  };

  const handleMailtoClick = (e: React.MouseEvent) => {
    const href = generateMailto();
    setMailtoHref(href);
    setTimeout(() => {
      window.location.href = href;
    }, 0);
    e.preventDefault();
  };

  useEffect(() => {
    if (open) {
      setMailtoHref(generateMailto());
    }
  }, [open]);

  if (!open) return null;
  return (
    <div className={styles['faq-dialog-wrapper']}>
      <StickyContainerView isOpen={open} name="faq-dialog">
        <div className={styles.faqDialogHeader}>
          <IconButton aria-label="close" onClick={onClose} className={styles.faqCloseButton}>
            <CloseIcon />
          </IconButton>
          <div className={styles.faqContactHeader}>{localizeMessage('faqContactHeader')}</div>
        </div>
        <div className={styles.faqDialogContent}>
          <div className={styles.faqHeader}>{localizeMessage('faqHeader')}</div>
          <FAQSectionList localizeMessage={localizeMessage} />
        </div>
        <div className={styles.faqFooter}>
          <div className={styles.faqFooterText}>{localizeMessage('faqFooterText')}</div>
          <a
            className={styles.faqFooterButton}
            href={mailtoHref}
            onClick={handleMailtoClick}
            role="button"
            tabIndex={0}
            aria-label={localizeMessage('faqFooterButton')}
          >
            {localizeMessage('faqFooterButton')}
          </a>
        </div>
      </StickyContainerView>
    </div>
  );
};
